module.exports = __webpack_public_path__ + "img/logo-genesis-3x.becdd534.png";